const view = (data, win = window) => new Promise((resolve, reject) => {
  if (typeof win === 'undefined') resolve();
  if (!win.metrics) reject(new Error('metrics undefined'));
  win.metrics.view(data, resolve);
});

const click = (data, cb, win = window) => new Promise((resolve, reject) => {
  if (typeof win === 'undefined') resolve();
  if (!win.metrics) reject(new Error('metrics undefined'));
  const callback = cb || resolve;
  win.metrics.link(data, callback);
});

export default { view, click };
